import { SetStateAction, useEffect, useState } from "react";
import { Loader } from "react-feather";
import { EditableCardField } from "./editable-card-field";
import { ReadonlyCardField } from "./readonly-card-field";
import { CreditCardInfo } from "./use-card-placeholder";

import styles from "./card-field.module.css";

type PaymentFieldComponentProps = {
    setIsValid: React.Dispatch<SetStateAction<boolean>>;
    existingCardInfo?: CreditCardInfo | null;
    loading: boolean;
    layout?: "default" | "bookingFlow";
};
export default function PaymentFieldComponent({
    setIsValid,
    existingCardInfo,
    loading,
    layout = "default",
}: PaymentFieldComponentProps): JSX.Element {
    const cardContainerClass =
        layout === "bookingFlow"
            ? `${styles["card-container"]} ${styles.cardContainerBookingFlow}`
            : styles["card-container"];
    const [isEditModeOn, setIsEditModeOn] = useState(!existingCardInfo);
    useEffect(() => {
        if (!loading && existingCardInfo) {
            setIsEditModeOn(false);
        }
    }, [loading, existingCardInfo]);

    if (loading) {
        return (
            <div id="card-element" className={cardContainerClass}>
                <Loader className="spinorama" style={{ margin: "auto" }} />
            </div>
        );
    }

    return isEditModeOn ? (
        <EditableCardField
            setIsValid={setIsValid}
            containerClassName={cardContainerClass}
        />
    ) : (
        <ReadonlyCardField
            creditCardInfo={existingCardInfo as CreditCardInfo}
            containerClassName={cardContainerClass}
            enableEditMode={() => {
                setIsEditModeOn(true);
                setIsValid(false);
            }}
        />
    );
}
